/**
 * This method ensures we consistently print dates. This also helps us ensure
 * the places where date formats are used as indexes to arrays are correct.
 * @param date
 * @returns {string}
 */
export function formatDate(date) {
    return date.toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    })
}